
import http from '@/base/api/public'
import querystring from 'querystring'

let apiUrl = require('@/../config/sysConfig')

// マスタデータ
export const conditionSearch = (page, div, type) => {
    let querys = querystring.stringify({ type: type })
    return http.requestQuickGet(apiUrl.apiurl_masterData + '/' + page + '/' + div + '?' + querys)
}
// 検索
export const myNoInfoGet = (userCd) => {
    return http.requestGet(apiUrl.apiUrl_MyNoInfo + '?userId=' + userCd)
}


// // 保存
// export const noticeSave = (saveParams, userCd) => {
//     return http.requestPost(apiUrl.apiUrl_Notice + '?userId=' + userCd, saveParams)
// }

//图片查询
export const photoFile_get = (photoPath) => {
    return http.requestQuickGetImage(apiUrl.apiUrl_FilesSearch + '?filePath=' + encodeURIComponent(photoPath) + '&resizeCd=0')
}

//图片保存
export const photoFile_saveImage = (photo) => {
    return http.requestPostFormData(apiUrl.apiUrl_filesUpdate, photo)
}


// メニュー状態管理検索
export const menuStateManagerGet = (userCd) => {
    return http.requestGet(apiUrl.apiurl_MenuStateManager + '?userId=' + userCd)
}

// マイナンバー申請保存
export const Apply_Save = (userCd, applySaveParams) => {
    return http.requestPost(apiUrl.apiUrl_MyNoInfo + '?userCd=' + userCd, applySaveParams)
}


// WEBPACK FOOTER //
// ./src/module/api/i_0006.js